function firstLetterUpper(theString) {
  const safeString = String(theString ?? '').trim()
  if (!safeString) return ''
  var newString = safeString.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g,function(c){return c.toUpperCase()});
  return newString;
}

export const toSentenceCase = (str) => {
  var theString = str
  var newString = firstLetterUpper(theString);
  return newString;
}

export const capitalize = (str, lower = false) => {
  const safeString = String(str ?? '')
  return (lower ? safeString.toLowerCase() : safeString).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase())
}

export const formatDetailText = (value, emptyValue = '-') => {
  const safeValue = String(value ?? '').trim()
  if (!safeValue) return emptyValue
  return capitalize(safeValue, true)
}

export const normalizeText = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()

export const capitalizeEachWord = (str) =>
  String(str ?? '')
    .trim()
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
